export const TEXT = {
  // 主要標題
  APP_TITLE: '儲存管理系統',
  STORAGE_DASHBOARD: '儲存儀表板',
  CUSTOMER_STORAGE_MANAGEMENT: '客戶儲存管理',

  // 導航
  DASHBOARD: '儀表板',
  CUSTOMERS: '客戶',

  // 統計卡片
  TOTAL_CUSTOMERS: '客戶總數',
  TOTAL_SPACE: '總空間',
  TOTAL_USED: '已使用空間',
  OVERALL_USAGE: '整體使用率',

  // 圖表和列表標題
  TOP_10_SPACE_USERS: '前 10 名空間使用者',
  TOP_10_NEAR_FULL: '空間即將用盡前 10 名',
  ALL_CUSTOMERS_OVERVIEW: '所有客戶概覽',

  // 表格標題
  CUSTOMER_ID: '客戶 ID',
  STORAGE_SERVERS: '儲存伺服器',
  CURRENT_SERVER: '目前伺服器',
  TOTAL_SPACE_TABLE: '總空間',
  USED_SPACE: '已使用空間',
  AVAILABLE: '可用空間',
  USAGE_PERCENT: '使用率',
  ACTIONS: '操作',

  // 按鈕和操作
  EDIT: '編輯',
  SAVE: '儲存',
  CANCEL: '取消',
  SEARCH: '搜尋',
  ADD_NEW_CUSTOMER: '新增客戶',
  ADD_CUSTOMER: '新增',
  CLOSE: '關閉',
  REFRESH: '重新整理',
  REFRESHING: '更新中...',

  // 搜尋占位符
  SEARCH_CUSTOMERS: '搜尋客戶...',
  SEARCH_CUSTOMER_ID: '搜尋客戶 ID...',

  // 狀態訊息
  LOADING: '載入中...',
  NO_DATA_AVAILABLE: '無可用資料',
  FAILED_TO_FETCH: '資料擷取失敗',
  NO_MATCHING_RESULTS: '沒有符合的結果',

  // 主題設定
  THEME_LIGHT: '淺色主題',
  THEME_DARK: '深色主題',
  THEME_SYSTEM: '系統主題',

  // 其他
  TOTAL: '總計',
  OF: '的',
  AVAILABLE_SPACE: '可用',
  USAGE: '使用情況',
  LAST_UPDATED: '最後更新',
  JUST_NOW: '剛剛',
  MINUTES_AGO: '分鐘前',
  SECONDS_AGO: '秒前',

  // 單位格式
  BYTES: '位元組',
  KB: 'KB',
  MB: 'MB',
  GB: 'GB',
  TB: 'TB',
};